module.exports = __webpack_public_path__ + "img/Weapon_229.de1ef8aa.png";